module.exports = __webpack_public_path__ + "static/media/interior_9.51e948c4.jpeg";